import React from 'react';

function AircraftTitle({ model, subtitle }) {
  return (
    <div className="aircraft-title">
      <h1 className="model-name">{model}</h1>
      <p className="model-subtitle">{subtitle}</p>
    </div>
  );
}

export default AircraftTitle;
